import React from 'react';
import { CreditCard, Lock, Terminal, Layers } from 'lucide-react';
import { SolutionCard } from './SolutionCard';
interface PaymentSolutionsProps {
  onNavigate?: (pageId: string) => void;
}
export function PaymentSolutions({
  onNavigate
}: PaymentSolutionsProps) {
  return <section className="py-12" data-id="element-238">
      <h2 className="text-xl text-gray-900 mb-10" data-id="element-239">
        Choose a payment solution, or combine payment solutions, that best fit
        your business.
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-240">
        <SolutionCard title="<<checkout>>" description="Fully hosted, fast, and easy payment page integration. Best for merchants who want to minimize PCI DSS scope." icon={CreditCard} onClick={() => onNavigate?.('checkout')} data-id="element-241" />

        <SolutionCard title="<<hostedSession>>" description="Simple iframe solution for a customizable payment form." icon={Lock} onClick={() => onNavigate?.('hosted-session')} data-id="element-242" />

        <SolutionCard title="<<directPayment>>" description="Fully control the transaction and manage the payment experience." icon={Terminal} onClick={() => onNavigate?.('direct-payment')} data-id="element-243" />

        <SolutionCard title="Hosted <<batchIntegration>>" description="Processes multiple operations securely and efficiently." icon={Layers} onClick={() => onNavigate?.('batch-integration')} data-id="element-244" />
      </div>
    </section>;
}